module.exports = __webpack_public_path__ + "img/part3-5.a70b24be.png";